export const sendWeeklySubscription = `
  mutation SendWeeklySubscription($id: String!) {
    sendWeeklySubscription(id: $id) {
      jobId
      status
      message
      sent
      failed
      error
    }
  }
`;
